import { createAction, props } from '@ngrx/store';
import { IPackageFilters } from '../../../package-filters/package-filters.component';

export const GET_ALL_PACKAGE_LISTING =
  '[Package Listing] Get All Package Listing';
export const GET_ALL_PACKAGE_LISTING_SUCCESS =
  '[Package Listing] Get All Package Listing Success';
export const GET_ALL_PACKAGE_LISTING_FAILURE =
  '[Package Listing] Get All Package Listing Failure';

export const getAllPackageListings = createAction(
  GET_ALL_PACKAGE_LISTING,
  props<{
    queryParams: IPackageFilters;
  }>()
);

export const getAllPackageListingsSuccess = createAction(
  GET_ALL_PACKAGE_LISTING_SUCCESS,
  props<{ data: any;pricingInfo: any; totalCount: number }>()
);

export const getAllPackageListingsFailure = createAction(
  GET_ALL_PACKAGE_LISTING_FAILURE,
  props<{ data: any }>()
);
